// file generated automatically by pipeline. Custom changes will be lost. Generator project is located - https://dev.azure.com/VolvoGroup-MASDCL/ProductCenter/_git/Tools

import administrationEnUS from './enUS/administration.json';
import boatEnUS from './enUS/boat.json';
import campaignEnUS from './enUS/campaign.json';
import commissioningEnUS from './enUS/commissioning.json';
import commonEnUS from './enUS/common.json';
import commonButtonEnUS from './enUS/commonButton.json';
import commonStatusEnUS from './enUS/commonStatus.json';
import commonUnitEnUS from './enUS/commonUnit.json';
import commonWizardEnUS from './enUS/commonWizard.json';
import componentEnUS from './enUS/component.json';
import componentInformationPlateEnUS from './enUS/componentInformationPlate.json';
import connectedUnitsEnUS from './enUS/connectedUnits.json';
import customerEnUS from './enUS/customer.json';
import deploymentAlertEnUS from './enUS/deploymentAlert.json';
import drivelineviewEnUS from './enUS/drivelineview.json';
import errorEnUS from './enUS/error.json';
import eventLogEnUS from './enUS/eventLog.json';
import fileUploadEnUS from './enUS/fileUpload.json';
import homeEnUS from './enUS/home.json';
import languageEnUS from './enUS/language.json';
import layoutEnUS from './enUS/layout.json';
import maintenancePlannerEnUS from './enUS/maintenancePlanner.json';
import menuEnUS from './enUS/menu.json';
import orderInfoEnUS from './enUS/orderInfo.json';
import productIndividualEnUS from './enUS/productIndividual.json';
import productInOperationEnUS from './enUS/productInOperation.json';
import productPopulationEnUS from './enUS/productPopulation.json';
import productTypeEnUS from './enUS/productType.json';
import releaseNotesEnUS from './enUS/releaseNotes.json';
import relocateToEnUS from './enUS/relocateTo.json';
import searchProductEnUS from './enUS/searchProduct.json';
import serviceProtocolEnUS from './enUS/serviceProtocol.json';
import unitCreationEnUS from './enUS/unitCreation.json';
import unitEditEnUS from './enUS/unitEdit.json';
import unitOverviewEnUS from './enUS/unitOverview.json';
import warrantyEnUS from './enUS/warranty.json';
import healthCheckEnUS from './enUS/healthCheck.json';

export const resources = {
    enUS: {
        administration: administrationEnUS,
        boat: boatEnUS,
        campaign: campaignEnUS,
        commissioning: commissioningEnUS,
        common: commonEnUS,
        commonButton: commonButtonEnUS,
        commonStatus: commonStatusEnUS,
        commonUnit: commonUnitEnUS,
        commonWizard: commonWizardEnUS,
        component: componentEnUS,
        componentInformationPlate: componentInformationPlateEnUS,
        connectedUnits: connectedUnitsEnUS,
        customer: customerEnUS,
        deploymentAlert: deploymentAlertEnUS,
        drivelineview: drivelineviewEnUS,
        error: errorEnUS,
        eventLog: eventLogEnUS,
        fileUpload: fileUploadEnUS,
        home: homeEnUS,
        language: languageEnUS,
        layout: layoutEnUS,
        maintenancePlanner: maintenancePlannerEnUS,
        menu: menuEnUS,
        orderInfo: orderInfoEnUS,
        productIndividual: productIndividualEnUS,
        productInOperation: productInOperationEnUS,
        productPopulation: productPopulationEnUS,
        productType: productTypeEnUS,
        releaseNotes: releaseNotesEnUS,
        relocateTo: relocateToEnUS,
        searchProduct: searchProductEnUS,
        serviceProtocol: serviceProtocolEnUS,
        unitCreation: unitCreationEnUS,
        unitEdit: unitEditEnUS,
        unitOverview: unitOverviewEnUS,
        warranty: warrantyEnUS,
        healthCheck: healthCheckEnUS,
    },
} as const;

export const namespaces = [
    'administration',
    'boat',
    'campaign',
    'commissioning',
    'common',
    'commonButton',
    'commonStatus',
    'commonUnit',
    'commonWizard',
    'component',
    'componentInformationPlate',
    'connectedUnits',
    'customer',
    'deploymentAlert',
    'drivelineview',
    'error',
    'eventLog',
    'fileUpload',
    'home',
    'language',
    'layout',
    'maintenancePlanner',
    'menu',
    'orderInfo',
    'productIndividual',
    'productInOperation',
    'productPopulation',
    'productType',
    'releaseNotes',
    'relocateTo',
    'searchProduct',
    'serviceProtocol',
    'unitCreation',
    'unitEdit',
    'unitOverview',
    'warranty',
    'healthCheck',
];
